export const STATUS_DO_REGISTRO = [
    { label: 'FINALIZADO', value: '1' },
    { label: 'NÃO FINALIZADO', value: '2' },
    { label: 'NÃO INICIADO', value: '3' },
    { label: 'TODOS', value: '4' },
]